/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Hold_OperationsInputs */

const en_wb_hold_operations = /** @type {(inputs: Wb_Hold_OperationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep on hold`)
};

const lv_wb_hold_operations = /** @type {(inputs: Wb_Hold_OperationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atstāt aizturētu`)
};

/**
* | output |
* | --- |
* | "Keep on hold" |
*
* @param {Wb_Hold_OperationsInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_hold_operations = /** @type {((inputs?: Wb_Hold_OperationsInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Hold_OperationsInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_hold_operations(inputs)
	return en_wb_hold_operations(inputs)
});